<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WniqC2/tc-custom/9783988269034.jpg?1704425604252" alt="This image is the cover for the book The Seven Curses of London, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Seven Curses of London, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>To certain squeamish readers this useful and well-written volume will prove an unsavoury book; and even to those who have the nerve to witness agony and explore the lurking-places of crime, it will occasion no ordinary sadness and sense of repugnance. Redolent with the unwholesome smell of ill-drained alleys and over-crowded dwellings for the poor, it resounds in every chapter with the cries of violence and the mutterings of woe ... [review of The Seven Curses of London from the Athenaeum, 1869]. The 'Curses' themselves are: 1. Neglected Children 2. Professional Thieves 3. Professional Beggars 4. Fallen Women 5. Drunkenness 6. Betting Gamblers 7. Waste of Charity. There is more of Greenwood's 'undercover' work, including a visit to a 'baby-farmer' — one of those women who advertised in the press to 'adopt' unwanted children for a fee (the fate of such unfortunates was often criminal abuse or neglect). Other vivid passages include interviews with convicts; begging-letter writers; harangues against the corrupting influence of penny dreadfuls (sample prose: "... pouting coral lips, in which a thousand tiny imps of love are lurking ..."); the unfortunate class of prostitutes known as 'dress-lodgers'; a full list of the ingredients used to adulterate beer ("... Multum is a mixture of opium and other ingredients, used to increase the intoxicating qualities of the liquor ... "); a survey of betting scams ("... Mr. Ben W. will forfeit £500 if he does not send first and second for the Chester Cup. Send four stamps and stamped envelope, and promise a present, and I will send you the Chester Cup, Great Northern, Derby, and Oaks winners ...") and a good deal more. All of these combine to paint a revealing picture of life in 1860s London, making this book worthy of your attention. (Amazon)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Greenwood
      </h2>
      
      <p class="authorDescription body article">James Greenwood (1832 – 10 December 1929) was an English social commentator, journalist, and prolific author. He was best known for his work as a reporter and writer during the Victorian era, where he focused on issues related to poverty, crime, and social reform. Greenwood's writings provided a window into the lives of the underprivileged and advocated for social change.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e9ce854